import { Color, ColorDynamic, useUID } from '@superdispatch/ui';
import { Button } from '@superdispatch/ui-lab';
import { InstantIcon } from 'shared/icons/InstantIcon';
import styled from 'styled-components';
import { trackLoadboardEvent } from '../../core/LoadboardAnalytics';

interface Props {
  value: boolean;
  onChange: (value: boolean) => void;
}
const ToggleButtonStyled = styled(Button)`
  width: 54px;
`;

export function PostingListFilterBookableButton({ value, onChange }: Props) {
  const uid = useUID();
  return (
    <ToggleButtonStyled
      variant="neutral"
      id={uid}
      active={value}
      onClick={() => {
        onChange(!value);
        trackLoadboardEvent({
          name: 'SLB: UI Interaction',
          type: 'Filter: Clicked Book Now filter',
        });
      }}
    >
      <InstantIcon htmlColor={value ? ColorDynamic.Blue500 : Color.Dark100} />
    </ToggleButtonStyled>
  );
}
